import WhenHomeTherapyTeamsGrowArticle from './articles/WhenHomeTherapyTeamsGrowArticle';
import WhyWhatsAppBreaksArticle from './articles/WhyWhatsAppBreaksArticle';
import SessionVerificationPayoutCycleArticle from './articles/SessionVerificationPayoutCycleArticle';
import PayoutDisputesHomeRehabArticle from './articles/PayoutDisputesHomeRehabArticle';
import WhyInsuranceClaimsRejectedArticle from './articles/WhyInsuranceClaimsRejectedArticle';
import WhyClinicSoftwareFailsArticle from './articles/WhyClinicSoftwareFailsArticle';
import HowToEvaluateSoftwareArticle from './articles/HowToEvaluateSoftwareArticle';
import { RESOURCE_POSTS } from '../medzhub-resources/posts';

const bySlug = (slug) => RESOURCE_POSTS.find((p) => p.slug === slug);

const REGISTRY = {
    'when-home-therapy-teams-grow-what-breaks-at-scale': {
        Article: WhenHomeTherapyTeamsGrowArticle,
        meta: () => {
            const p = bySlug('when-home-therapy-teams-grow-what-breaks-at-scale');
            return { title: p.title, description: p.seoDescription };
        },
    },
    'why-whatsapp-breaks-field-operations-system': {
        Article: WhyWhatsAppBreaksArticle,
        meta: () => {
            const p = bySlug('why-whatsapp-breaks-field-operations-system');
            return { title: p.title, description: p.seoDescription };
        },
    },
    'session-verification-payout-cycle-home-rehab': {
        Article: SessionVerificationPayoutCycleArticle,
        meta: () => {
            const p = bySlug('session-verification-payout-cycle-home-rehab');
            return { title: p.title, description: p.seoDescription };
        },
    },
    'payout-disputes-home-rehab-fix': {
        Article: PayoutDisputesHomeRehabArticle,
        meta: () => {
            const p = bySlug('payout-disputes-home-rehab-fix');
            return { title: p.title, description: p.seoDescription };
        },
    },
    'why-insurance-claims-rejected-home-rehab': {
        Article: WhyInsuranceClaimsRejectedArticle,
        meta: () => {
            const p = bySlug('why-insurance-claims-rejected-home-rehab');
            return { title: p.title, description: p.seoDescription };
        },
    },
    'why-clinic-software-fails-home-visit-teams': {
        Article: WhyClinicSoftwareFailsArticle,
        meta: () => {
            const p = bySlug('why-clinic-software-fails-home-visit-teams');
            return { title: p.title, description: p.seoDescription };
        },
    },
    'how-to-evaluate-software-field-therapy-teams': {
        Article: HowToEvaluateSoftwareArticle,
        meta: () => {
            const p = bySlug('how-to-evaluate-software-field-therapy-teams');
            return { title: p.title, description: p.seoDescription };
        },
    },
};

export const ARTICLE_SLUGS = Object.keys(REGISTRY);

export function getArticle(slug) {
    return REGISTRY[slug] ?? null;
}
